import { IOfferSpendListTableLang } from '../../../types/lang'

export const offerSpendListTableLang: IOfferSpendListTableLang = {
	offer_spend_list_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_date_updated: 'Date Updated',
		column_amount: 'Amount',
		column_account_id: 'Account ID',
		column_account: 'Account',
		column_account_in_group: 'Account in Group',
		column_kt_group: 'KT Group',
		column_offer_id: 'Offer ID',
		column_offer: 'Offer',
		column_scope_id: 'Scope ID',
		column_scope: 'Scope',
		column_history: 'History',
		column_notes: 'Notes'
	}
}